const WhyChooseUs = () => {
  const reasons = [
    {
      number: '①',
      label: '実装力',
      title: '業務を激変させるAI・RAGシステムの構築',
      description:
        '単なるAIツールの導入にとどまらず、企業の独自データや基盤システムとセキュアに連携する「RAG（検索拡張生成）」などのAI組み込み型システムを開発。AIエージェントを使いこなした超高速・高品質な開発（AIオーケストレーション）により、上流工程から実装までを最短で形にします。',
      icon: 'ri-code-box-line',
    },
    {
      number: '②',
      label: '信頼性',
      title: '自社システムでの「実稼働データ」という証明',
      description:
        '当社がご提供するAIシステムや自動化インフラは、すべて自社内の基盤システムに先行導入し、現在進行形で安定稼働している検証済みノウハウです。机上の空論ではない、現場で磨かれたリアルな「動くシステム」をご提供します。',
      icon: 'ri-shield-star-line',
    },
    {
      number: '③',
      label: '防御力',
      title: 'インフラ＆システムの「ペンテスト」を標準網羅',
      description:
        'AIの導入で最も懸念されるのが「情報漏洩」や「サイバー攻撃」のリスクです。当社は、システム開発の段階から、攻撃者の視点で疑似攻撃を仕掛ける「インフラペンテスト」「システムペンテスト」までを自社内で徹底実施。脆弱性を徹底的に潰した、強固なシステムを納品します。',
      icon: 'ri-shield-keyhole-line',
    },
    {
      number: '④',
      label: '監視力',
      title: 'AIによる24時間365日のセキュア監視体制',
      description:
        'システムは作って終わりではありません。納品後も、最先端の「AI監視システム」を導入し、24時間365日体制で不審なアクセスやセキュリティインシデントを自動検知。常に安全な運用環境をキープします。',
      icon: 'ri-radar-line',
    },
  ];

  return (
    <section id="why-choose-us" className="py-16 bg-white">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-10">
        <div className="text-center mb-12">
          <p className="text-[#5DAA68] text-xs font-semibold tracking-[0.2em] uppercase mb-3 font-['Inter']">
            Why MSK
          </p>
          <h2 className="text-2xl md:text-3xl font-bold text-[#89B56B] font-['Noto_Sans_JP']">
            当社が選ばれる４つの理由
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {reasons.map((reason) => (
            <div
              key={reason.label}
              className="bg-[#F8FAF6] rounded-2xl p-6 md:p-8 shadow-[0_2px_16px_rgba(0,0,0,0.04)] hover:shadow-[0_8px_32px_rgba(137,181,107,0.12)] transition-all duration-300"
            >
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#89B56B]/10 flex-shrink-0">
                  <i className={`${reason.icon} text-[#5DAA68] text-xl`} />
                </div>
                <div>
                  <p className="text-xs font-semibold text-[#5DAA68] tracking-wider mb-1">
                    {reason.number} 【{reason.label}】
                  </p>
                  <h3 className="text-base md:text-lg font-bold text-[#89B56B] leading-relaxed">
                    {reason.title}
                  </h3>
                </div>
              </div>
              <p className="text-sm text-gray-600 leading-[2]">{reason.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
